import { store } from '@/store'

export const converter = (fieldBase = null) => {
  if (!Array.isArray(fieldBase)) return fieldBase
  const language = store.state.languages.listLanguages
  let result = []
  if (!language) {
    return result
  }
  if (fieldBase && fieldBase.length) {
    language.forEach(item => {
      let search = fieldBase.find(element => element.langId === item._id)
      if (!search) {
        search = item
      }
      result.push({
        text: search.text || '',
        name: item.name,
        langId: item._id
      })
    })
    return result
  }
  language.forEach(item => {
    result.push({
      text: '',
      name: item.name,
      langId: item._id
    })
  })
  return result
}

const mixinConverterLanguage = {
  methods: {
    converter(fieldBase = null) {
      return converter(fieldBase)
    }
  }
}

export default mixinConverterLanguage
